import {SearchModel} from "@fedelta-pos/data-client";
import {Injectable, Injector, inject} from "@angular/core";
import {ScheduleData} from '../menu/menu-entity.model';


/**
 * Search model to retrieve the current active schedules
 */
@Injectable()
export class ActiveSchedulesSearchModel extends SearchModel<ScheduleData> {
    constructor() {
        console.log("--- ActiveSchedulesSearchModel");
        super(inject(Injector), ScheduleData);
    }
}
